export const NOTIFICATIONS_QUERY_KEY = 'notifications';

export const NOTIFICATIONS_CHANNEL_PREFIX = 'notifications-channel';

export const NOTIFICATIONS_PAGE_SIZE = 20;

export const NOTIFICATIONS_SCROLLABLE_TARGET_ID =
  'notification-scroll-container';

export const NOTIFICATIONS_STALE_TIME = 30000; // 30 seconds
export const NOTIFICATIONS_GC_TIME = 5 * 60 * 1000; // 5 minutes

export const NOTIFICATIONS_QUERY_OPTIONS = {
  staleTime: NOTIFICATIONS_STALE_TIME,
  gcTime: NOTIFICATIONS_GC_TIME,
};

export const NotificationDateGroup = {
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  THIS_WEEK: 'this-week',
  THIS_MONTH: 'this-month',
  THIS_YEAR: 'this-year',
  OLDER: 'older',
} as const;
export type NotificationDateGroup =
  (typeof NotificationDateGroup)[keyof typeof NotificationDateGroup];
